import { render, staticRenderFns } from "./SpaceList.vue?vue&type=template&id=1a347955"
import script from "./SpaceList.vue?vue&type=script&lang=js"
export * from "./SpaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports